/** Shopify CDN: Minification failed

Line 43:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 44:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 46:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 54:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 60:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 66:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 30:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 34:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 40:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 45:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 56:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 20:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 26:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 31:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 32:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 42:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');

    const CN_ACTIVE = '!active';

    customElements.define('scroll-to-top-button', class extends Core {
        elements = {
            trigger: '[data-trigger]',
            button: '[data-button]'
        }

        render() {
            this._handleTrigger();
            this._handleClick();
        }

        _handleTrigger() {
            const observer = new IntersectionObserver((entries) => {
                this.active = !entries[0].isIntersecting;
            });
            observer.observe(this.$trigger);
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this));
        }

        _onClick() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        set active(state) {
            this.$button.classList.toggle(CN_ACTIVE, state);
        }
    });
})(); 